const FORBIDDEN_NAME_CHARACTERS = /[\\/:*?"<>|]/;

// A NUL cannot be stored by Postgres, and no control character has a place in a name anybody reads.
// The characters that reorder what is shown are refused too: a name with a right-to-left override
// in it reads as another file than the one it is.
const isUnsafeCharacter = (character: string): boolean => {
  const code = character.codePointAt(0) ?? 0;

  return (
    code < 0x20 ||
    (code >= 0x7f && code <= 0x9f) ||
    code === 0x200e ||
    code === 0x200f ||
    (code >= 0x202a && code <= 0x202e) ||
    (code >= 0x2066 && code <= 0x2069)
  );
};

export const hasForbiddenNameCharacters = (name: string): boolean =>
  FORBIDDEN_NAME_CHARACTERS.test(name) || [...name].some(isUnsafeCharacter);

// Letters and digits with at least one letter: `pdf`, `docx`, `7z`. What follows the last dot of
// `Notes 1.5` or `v1.2` is a number in a name, not a type.
const EXTENSION = /^(?=.*[a-z])[a-z0-9]{1,10}$/;

/**
 * A file's extension, lower-cased and without the dot; empty when there is none. A rename may not
 * change it, because a file keeps the type it was uploaded as.
 */
export const spaceFileExtension = (name: string): string => {
  const dot = name.lastIndexOf('.');
  const extension = name.slice(dot + 1).toLowerCase();

  return dot !== -1 && EXTENSION.test(extension) ? extension : '';
};
